import { createApi } from '@reduxjs/toolkit/query/react'
import { hcPortalBaseQuery } from '@/features/baseQuery.ts'
import { ProbationRecord, ProbationRecordDetails } from '@/features/probation/probation.def.ts'
import {
  CreateProbationRecordRequest,
  GetProbationRecordByIdRequest,
  UpdateProbationRecordRequest,
} from '@/features/probation/probation-request.def.ts'

export const probationApi = createApi({
  reducerPath: 'probationApi',
  baseQuery: hcPortalBaseQuery(),
  tagTypes: ['ProbationRecord'],
  endpoints: (builder) => ({
    getProbationRecords: builder.query<ProbationRecord[], void>({
      query: () => ({
        url: 'Probation/GetProbationRecords',
        method: 'GET',
      }),
      providesTags: () => [{ type: 'ProbationRecord', id: 'LIST' }],
    }),
    getProbationRecordById: builder.query<ProbationRecordDetails, GetProbationRecordByIdRequest>({
      query: (request) => ({
        url: 'Probation/GetProbationRecordById',
        params: request,
      }),
      providesTags: (_, __, { id }) => [{ type: 'ProbationRecord', id }],
    }),
    createProbationRecord: builder.mutation<ProbationRecord, CreateProbationRecordRequest>({
      query: (request) => ({
        url: 'Probation/CreateProbationRecord',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: [{ type: 'ProbationRecord', id: 'LIST' }],
    }),
    updateProbationRecord: builder.mutation<boolean, UpdateProbationRecordRequest>({
      query: (request) => ({
        url: 'Probation/UpdateProbationRecord',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: (_, __, { id }) => [
        { type: 'ProbationRecord', id },
      ],
    }),
  }),
})

export const {
  useGetProbationRecordsQuery,
  useGetProbationRecordByIdQuery,
  useCreateProbationRecordMutation,
  useUpdateProbationRecordMutation,
} = probationApi
